import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import DateFormat from "../../../components/DateFormat";
import { getStandingsPositionStyle } from "../../../utils/Standings";

const EventResults = ({ events }: { events: EventResults[] }) => {
  const { t } = useTranslation();
  return (
    <div className="events-container flex">
      {events.map((event, index) => {
        return (
          <div
            key={index}
            className={`${getStandingsPositionStyle(event.position)}`}
          >
            <Link
              to={`${t("routes:GrandPrix")}/${encodeURIComponent(
                event.name.replace(/ /g, "")
              )}`}
              className="driver"
              title={event.name}
            >
              {event.name}
            </Link>
            <DateFormat date={event.date.toString()} format={"normal"} />
            <div className="flex">
              <img
                src={`/assets/Games/${event.game}.png`}
                alt={event.game}
                title={event.game}
                className="game-icon"
              />
              <div className="full-width flex-center">
                <span className={`event-pos`}>
                  {event.position}
                  {!Number.isNaN(Number(event.position)) ? "º" : ""}
                </span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
export default EventResults;
